//3rd Party Components
import React, { Fragment } from 'react';
import { useSelector } from "react-redux";

//Components
import Menu from "../../components/Portal/Menu";
import logo from '../../images/CASALOGO-white-i.svg';

//Actions
import { getPortalUrl } from '../../components/Portal/Utilities';
import { getUrlSelector } from '../../PortalStore/Selectors/EnvDataSelectors';

const HeaderContent = () => {
    let userdetails = useSelector(state => state.userdetails);
    let standalone = useSelector(state => state.B2CSettings.items.standalone);
    let urlHome = useSelector(state => getUrlSelector(state, "Portal - Home URL"));

    const menu = () => {
        let menujsx = "";

        if (userdetails !== null && userdetails.loaded && userdetails.items.value[0] !== null && userdetails.items.value[0].contactid !== "") {
            let portalUrl = getPortalUrl("/logoff", standalone, urlHome);
            menujsx = <Menu signoutLink={portalUrl} />;
        }
        else {
            menujsx = null;
        }

        return menujsx;
    }

    const home = () => {
        let portalUrl = "";

        if (userdetails !== null && userdetails.loaded && userdetails.items.value[0] !== null && userdetails.items.value[0].contactid !== "") {
            portalUrl = getPortalUrl("", standalone, urlHome);
        }
        else {
            portalUrl = "/";
        }

        return portalUrl;
    }
    
    return (
        <Fragment>
            <div className="header">
                <div className="container">
                    <div className="au-row">

                        <div className="logo au-body au-body--dark">
                            <a href={home()}>
                                <img src={logo} alt="Civil Aviation Safety Authority logo"></img>
                            </a>
                        </div>
                        
                        {menu()}
                        
                        </div>

                </div>
            </div>
            <div className="body">
                <div className="banner">
                </div>
            </div>
        </Fragment>
    );
    
}

export default HeaderContent;
